(function () {
  'use strict';

  var GTM = window.__GTM || {};
  var SHOP = GTM.shopName || '';

  // Utility: push ecommerce event (con reset obbligatorio)
  function pushEcommerce(eventName, ecommerceData) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({ event: eventName }, { ecommerce: ecommerceData }));
  }

  // Utility: mappa un item del carrello Shopify nello schema GA4
  function itemFromCartItem(item) {
    return {
      item_id: String(item.variant_id || item.id),
      item_name: item.product_title || item.title,
      item_brand: item.vendor || SHOP,
      item_category: item.product_type || '',
      item_variant: item.variant_title !== 'Default Title' ? (item.variant_title || '') : '',
      price: item.final_price / 100,
      quantity: item.quantity,
    };
  }

  // ─── page_view ───────────────────────────────────────────────────────────────
  window.dataLayer.push({
    event: 'page_view',
    page_type: GTM.pageType || 'other',
  });

  // ─── view_item ───────────────────────────────────────────────────────────────
  if (GTM.pageType === 'product' && GTM.product) {
    var p = GTM.product;
    pushEcommerce('view_item', {
      currency: GTM.currency,
      value: p.price,
      items: [{
        item_id: String(p.variantId),
        item_name: p.title,
        item_brand: p.vendor || SHOP,
        item_category: p.category,
        item_variant: p.variantTitle !== 'Default Title' ? (p.variantTitle || '') : '',
        price: p.price,
        quantity: 1,
      }],
    });
  }

  // ─── view_item_list ──────────────────────────────────────────────────────────
  if (GTM.pageType === 'collection' && GTM.collection) {
    var c = GTM.collection;
    pushEcommerce('view_item_list', {
      item_list_name: c.title,
      item_list_id: c.handle,
      items: c.products.map(function (prod) {
        return {
          item_id: String(prod.variantId),
          item_name: prod.title,
          item_brand: prod.vendor || SHOP,
          item_category: prod.category,
          price: prod.price,
          index: prod.position,
        };
      }),
    });
  }

  // ─── add_to_cart / remove_from_cart via snapshot diff ────────────────────────
  var cartSnapshot = { items: [], total_price: 0 };

  // Carica snapshot iniziale
  var snapshotReady = fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { cartSnapshot = cart; });

  function diffCarts(prev, next) {
    var prevMap = {};
    prev.items.forEach(function (i) { prevMap[i.variant_id] = i; });
    var nextMap = {};
    next.items.forEach(function (i) { nextMap[i.variant_id] = i; });

    var added = [];
    var removed = [];

    next.items.forEach(function (item) {
      var prevItem = prevMap[item.variant_id];
      if (!prevItem) {
        added.push(item);
      } else if (item.quantity > prevItem.quantity) {
        added.push(Object.assign({}, item, { quantity: item.quantity - prevItem.quantity }));
      }
    });

    prev.items.forEach(function (item) {
      var nextItem = nextMap[item.variant_id];
      if (!nextItem) {
        removed.push(item);
      } else if (item.quantity > nextItem.quantity) {
        removed.push(Object.assign({}, item, { quantity: item.quantity - nextItem.quantity }));
      }
    });

    return { added: added, removed: removed };
  }

  // subscribe è globale da pubsub.js, PUB_SUB_EVENTS da constants.js
  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    snapshotReady.then(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (newCart) {
          var diff = diffCarts(cartSnapshot, newCart);

          if (diff.added.length > 0) {
            var value = diff.added.reduce(function (sum, i) {
              return sum + (i.final_price / 100) * i.quantity;
            }, 0);
            pushEcommerce('add_to_cart', {
              currency: GTM.currency,
              value: Math.round(value * 100) / 100,
              items: diff.added.map(itemFromCartItem),
            });
          }

          if (diff.removed.length > 0) {
            var removedValue = diff.removed.reduce(function (sum, i) {
              return sum + (i.final_price / 100) * i.quantity;
            }, 0);
            pushEcommerce('remove_from_cart', {
              currency: GTM.currency,
              value: Math.round(removedValue * 100) / 100,
              items: diff.removed.map(itemFromCartItem),
            });
          }

          cartSnapshot = newCart;
        });
    });
  });

  // ─── view_cart ───────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '[data-cart-icon-bubble], .cart-drawer__toggle, a[href="/cart"]'
    );
    if (!trigger) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;
        pushEcommerce('view_cart', {
          currency: GTM.currency,
          value: cart.total_price / 100,
          items: cart.items.map(itemFromCartItem),
        });
      });
  });

  // ─── search ──────────────────────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/search"]');
    if (!form) return;
    var input = form.querySelector('[name="q"]');
    if (!input || !input.value.trim()) return;
    window.dataLayer.push({
      event: 'search',
      search_term: input.value.trim(),
    });
  });

  // ─── begin_checkout ──────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '[name="checkout"], .cart__checkout-button, a[href^="/checkout"]'
    );
    if (!trigger) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;
        pushEcommerce('begin_checkout', {
          currency: GTM.currency,
          value: cart.total_price / 100,
          items: cart.items.map(itemFromCartItem),
        });
      });
  });

})();
